import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import logoPsp from "../../assets/images/icon_home/logo-psp.svg";
import drop from "../../assets/images/icon_home/drop.svg";
import handLeft from "../../assets/images/icon_home/hand-left.svg";
import handRight from "../../assets/images/icon_home/hand-right.svg";
import notification from "../../assets/images/icon_home/notification.svg";
import arrowRight from "../../assets/images/icon_home/arrow-right.svg";
import wallet from "../../assets/images/icon_home/wallet.svg";
import all from "../../assets/images/icon_home/all.svg";
import close from "../../assets/images/icon_login/close-square.svg";
import card from "../../assets/images/icon_home/card.svg";
import addUser from "../../assets/images/icon_home/add-user.svg";
import transaction from "../../assets/images/icon_home/transaction.svg";
import mutation from "../../assets/images/icon_home/mutation.svg";
import attendance from "../../assets/images/icon_home/attendance.svg";
import saving from "../../assets/images/icon_home/saving.svg";
import timetable from "../../assets/images/icon_home/timetable.svg";
import invoice from "../../assets/images/icon_home/invoice.svg";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import info from "../../assets/images/icon_home/info.svg";
import banner from "../../assets/images/icon_stock/banner.png";
import donation from "../../assets/images/icon_home/donation.svg";
import schedule from "../../assets/images/icon_home/schedule.svg";
import calendar from "../../assets/images/icon_home/Calendar.svg";
import savings from "../../assets/images/icon_home/savings.svg";
import support from "../../assets/images/icon_home/support.svg";
import * as API from "../../core/service/api.js";
import { } from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import * as api_notification from "../../core/service/api_notification";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency, showSvg } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Transition, Tab, Dialog } from "@headlessui/react";
import moment from "moment";
import Navbar from "../common/Navbar";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import CustomApp from "../../core/models/customApp";
import Slider from "react-slick";
import { log } from "console";
import _, { delay } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { isDarkColor } from "../../config/DarkColorChecker";

const MessageMobile = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [notifData, setNotifData] = useState([]);
  const [broadcastData, setBroadcastData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [specialAction, setSpecialAction] = useState(false);
  let [isDetailOpen, setIsDetailOpen] = useState(false);
  let [isDetailBcOpen, setIsDetailBcOpen] = useState(false);
  let [selectedItem, setSelectedItem] = useState<any>({});
  let [bcImages, setBcImages] = useState<any>([]);

  let [loading, setLoading] = useState(false);
  let [noNotifData, setNoNotifData] = useState(false);
  let [noBcData, setNoBcData] = useState(false);
  let [notifPage, setNotifPage] = useState(0);
  let [bcPage, setBcPage] = useState(0);
  const { t } = useTranslation();
  const [menu, setMenu] = useState<any>([]);

  var notification = `${t("INBOX.notification")}`;
  var broadcast = `${t("INBOX.broadcast")}`;
  let [categories] = useState({
    [notification]: [],
    [broadcast]: [],
  });

  const default_menu = [
    {
      menu_name: t("HOME.menu.topup"),
      menu_icon_url: wallet,
      menu_path: "/topup",
      menu_is_show: true,
    },
    {
      menu_name: t("HOME.menu.invoice"),
      menu_icon_url: invoice,
      menu_is_show: true,
      menu_path: "/invoice",
    },
    {
      name: t("HOME.menu.mutation"),
      menu_icon_url: mutation,
      menu_is_show: true,
      menu_path: "/mutation",
    },
    {
      name: t("HOME.menu.transaction"),
      menu_icon_url: transaction,
      menu_is_show: true,
      menu_path: "/transaction-history",
    },
    {
      name: t("HOME.menu.attendance"),
      menu_icon_url: attendance,
      menu_is_show: true,
      menu_path: "/attendance",
    },
    {
      name: t("HOME.menu.digitalCard"),
      menu_icon_url: card,
      menu_is_show: true,
      menu_path: "/digital-card",
    },
    {
      name: t("HOME.menu.account"),
      menu_icon_url: addUser,
      menu_is_show: true,
      menu_path: "/account",
    },
    {
      name: t("HOME.menu.donation"),
      menu_icon_url: donation,
      menu_is_show: true,
      menu_path: "/donation",
    },
    {
      name: t("HOME.menu.timetable"),
      menu_icon_url: timetable,
      menu_is_show: true,
      menu_path: "/schedule",
    },
    {
      name: t("HOME.menu.calendarAcademic"),
      menu_icon_url: calendar,
      menu_is_show: true,
      menu_path: "/calendar",
    },

    {
      name: t("HOME.menu.support"),
      menu_icon_url: support,
      menu_is_show: true,
      menu_path: "/etc",
    },
  ];

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginRight: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginLeft: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  window.onscroll = () => {
    const difference =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollposition = document.documentElement.scrollTop;
    if (difference - scrollposition <= 2) {
      console.log("bottom");
      if (activeTab == 0) {
        if (!noNotifData) {
          getNotifData();
        }
      } else {
        if (!noBcData) {
          getBcData();
        }
      }
    }
  };

  function closeDetailModal() {
    setIsDetailOpen(false);
    setIsDetailBcOpen(false);
  }

  function openDetailModal(item: any) {
    console.log(item);
    setSelectedItem(item);
    setIsDetailOpen(true);
  }

  function openDetailBcModal(item: any) {
    setBcImages(item.images);
    console.log(item);
    setSelectedItem(item);
    setIsDetailBcOpen(true);
  }

  function getNotifData() {
    console.log("getNotifData");
    api_notification.getNotifData(notifPage, 10).then((res) => {
      if (notifPage < res.data.totalPages) {
        console.log(res);
        let temp = notifData.concat(res.data.content);
        setNotifData(temp);
        increasePage("notif");
      }
      if (res.data.content.length === 0) {
        setNoNotifData(true);
      }
    });
  }

  function getBcData() {
    console.log("getBcData");
    closeDetailModal();
    api_notification.getBcData(bcPage, 10).then((res) => {
      if (bcPage < res.data.totalPages) {
        console.log(res);
        let temp = broadcastData.concat(res.data.content);
        setBroadcastData(temp);
        increasePage("bc");
      }
      if (res.data.content.length === 0) {
        setNoBcData(true);
      }
    });
  }

  function getData(index: any) {
    if (index == 0) {
      getNotifData();
    } else {
      getBcData();
    }
    setActiveTab(index);
  }

  function increasePage(type: any) {
    if (type === "notif") {
      let page = notifPage;
      page += 1;
      setNotifPage(page);
    } else {
      let page = bcPage;
      page += 1;
      setBcPage(page);
    }
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  const env = Config.BaseUrlDev;

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    // afterChange: function (index: number) {
    //   console.log(
    //     `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
    //   );
    // },
  };

  useEffect(() => {
    var token = location.pathname.split("/")[2];
    if (location.pathname.split("/")[3] != undefined) {
      var lang = location.pathname.split("/")[3];
      i18n.changeLanguage(lang);
      dispatch(setLanguage(lang));
    }

    if (location.pathname.split("/")[4] != undefined) {
      var tab = location.pathname.split("/")[4];
      if (user == undefined) {
        navigate("/login", { replace: true });
      } else {
        setActiveTab(parseInt(tab));
        getData(tab);
        setSpecialAction(true);
        console.log(broadcastData);
      }
    } else {
      if (token != undefined) {
        dispatch(setToken(location.pathname.split("/")[2]));
        API.credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
          navigate("/message");
        });
      } else {
        if (user == undefined) {
          navigate("/login", { replace: true });
        } else {
          getData(activeTab);
        }
      }

    }
  }, [location.pathname.split("/")[2]]);

  const getCustomApp = async () => {
    var temp: any = [];
    customApp?.app_menu.map((menu: any, key: number) => {
      API.getIconApps(customApp.company_id, menu.menu_icon_url)
        .then((res: any) => {
          temp[key] = {
            id: menu.id,
            menu_icon_url: showSvg(res.data),
            menu_is_show: menu.menu_is_show,
            menu_name: menu.menu_name,
            menu_path: menu.menu_path,
            menu_type: menu.menu_type,
          };
        })
        .catch((err: any) => {
          var icon = _.find(default_menu, { menu_path: menu.menu_path });
          temp[key] = {
            id: menu.id,
            menu_icon_url: icon?.menu_icon_url,
            menu_is_show: menu.menu_is_show,
            menu_name: menu.menu_name,
            menu_path: menu.menu_path,
            menu_type: menu.menu_type,
          };
        });
    });
    setMenu(temp);
  };
  useEffect(() => {
    getCustomApp();
  }, [customApp]);
  useEffect(() => {
    console.log(specialAction);
    console.log(broadcastData);
    if (specialAction == true && broadcastData.length > 1) {
      openDetailBcModal(broadcastData[0]);
      setSpecialAction(false);
    }
  }, [specialAction, broadcastData]);
  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <div className="fixed bg-psp-primary p-3 w-full">
          <h1 className="font-montserrat m-0 font-bold text-base text-black">
            {`${t("INBOX.title")}`}
          </h1>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-4 bg-psp-primary ">
          <section className="mt-8">
            <div>
              <Tab.Group
                selectedIndex={activeTab}
                onChange={(index) => {
                  console.log("Changed selected tab to:", index);
                  getData(index);
                }}
              >
                <Tab.List className="flex space-x-1 bg-psp-primary sticky top-12 z-[25]">
                  {Object.keys(categories).map((category, key) => (
                    <Tab
                      key={category}
                      style={{
                        background: activeTab == key? customApp.app_accent_color : "",
                        color:
                          activeTab == key
                            ? customApp?.app_accent_color
                            : "#fff",
                      }}
                      className={({ selected }) =>
                        classNames(
                          "w-full py-2.5 text-sm font-medium",
                          " ",
                          selected
                            ? `font-montserrat rounded-xl text-sm font-semibold ${isDarkColor(customApp.app_accent_color)?"text-white":"text-black"}`
                            : "text-black font-montserrat text-sm font-semibold"
                        )
                      }
                    >
                      {category}
                    </Tab>
                  ))}
                </Tab.List>
                <Tab.Panels className="mt-2">
                  <Tab.Panel className="top-to-bottom">
                    <div className="flex flex-col gap-3">
                      {notifData.map((item: any) => (
                        <div
                          className="bg-white rounded-xl gap-4 items-center"
                          onClick={() => {
                            openDetailModal(item);
                          }}
                          key={item.id}
                        >
                          <div className="p-3">
                            <h1 className=" m-0 col-span-2 text-xs font-bold font-montserrat">
                              {item.title}
                            </h1>
                            <h1
                              className=" m-0 col-span-2 text-xs font-normal font-montserrat"
                              dangerouslySetInnerHTML={{ __html: item.message }}
                            ></h1>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Tab.Panel>
                  <Tab.Panel className="top-to-bottom">
                    <div className="flex flex-col gap-3">
                      {broadcastData.map((item: any) => {
                        var meseg = item.message.length > 250 ? item.message.substring(0, 150) + "...." : item.message
                        return (
                          <div
                            className={"bg-white rounded-xl flex flex-col"}
                            onClick={() => {
                              openDetailBcModal(item);
                            }}
                          >
                            {item.imagesFirebase.length === 0 ? null : (
                              <div className=" w-full">

                                <div className="h-full w-full">
                                  <img
                                    src={item.imagesFirebase}
                                    alt=""
                                    className="h-auto w-full flex mx-auto rounded-2xl p-2"
                                  />
                                </div>
                              </div>
                            )}
                            <div className="p-3">
                              <p className="text-[12px] text-gray-400 font-montserrat">{moment(item.broadcastSent).format("DD/MM/YYYY")}</p>
                              <h1 className=" m-0 col-span-2 text-xs font-bold font-montserrat">
                                {item.title}
                              </h1>
                              <h1
                                className=" m-0 col-span-2 text-xs font-normal font-montserrat"
                                dangerouslySetInnerHTML={{ __html: meseg }}
                              ></h1>
                            </div>
                          </div>
                        )
                      }

                      )}
                    </div>
                  </Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </div>
          </section>
        </div>
        <Tabs tab={`${t("NAVBAR.inbox")}`}></Tabs>
      </div>
      <Transition appear show={isDetailOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[1000]"
          onClose={closeDetailModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="m-0 font-montserrat text-sm font-semibold leading-5 text-gray-900"
                  >
                    {selectedItem.title}
                    <p className="m-0 mb-2 font-montserrat text-[11px] text-gray-500">
                      {moment(selectedItem.createdTime).format(
                        "YYYY/MM/DD HH:mm"
                      )}
                    </p>
                  </Dialog.Title>
                  <div className="mt-px">
                    <p
                      className="font-montserrat text-[11px] text-gray-500"
                      dangerouslySetInnerHTML={{
                        __html: String(selectedItem.message).replace(
                          "******",
                          selectedItem.content
                        ),
                      }}
                    ></p>
                  </div>

                  <div className="mt-3">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-[11px] font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeDetailModal}
                    >
                      {t("OTHER.close")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={isDetailBcOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[1000]"
          onClose={closeDetailModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Swiper
                    autoplay={true}
                    pagination={{ clickable: true, type: "fraction" }}
                    centeredSlides={true}
                    speed={500}
                    navigation
                    slidesPerView={1}
                    modules={[Pagination, Navigation, Autoplay]}
                    className="justify-center"
                  >
                    {bcImages.map((item: any) => (
                      <SwiperSlide className="justify-center items-center relative flex h-auto">

                        <LazyLoadImage
                          className="rounded-2xl h-auto w-auto object-fill relative"
                          effect="blur"
                          src={getImgContent(item)}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <Dialog.Title
                    as="h3"
                    className="mt-3 font-montserrat text-sm font-semibold leading-6 text-gray-900"
                  >
                    {selectedItem.title}
                    <p className="font-montserrat text-[11px] text-gray-500 m-0 mb-1">
                      {selectedItem.subtitle}
                    </p>
                    <p className="font-montserrat text-[10px] text-gray-500 m-0 hidden">
                      {t("OTHER.from")}:{" "}
                      {moment(selectedItem.startTime).format(
                        "YYYY/MM/DD HH:mm"
                      )}
                    </p>
                    <p className="font-montserrat text-[10px] text-gray-500 m-0 hidden">
                      {t("OTHER.to")}:{" "}
                      {moment(selectedItem.endTime).format("YYYY/MM/DD HH:mm")}
                    </p>
                    <hr className="m-0 my-1" />
                  </Dialog.Title>
                  <div className="mt-2">
                    <p
                      className="font-montserrat text-[11px] text-gray-500"
                      dangerouslySetInnerHTML={{
                        __html: String(selectedItem.message).replace(
                          "******",
                          selectedItem.content
                        ),
                      }}
                    ></p>
                  </div>
                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-[11px] font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeDetailModal}
                    >
                      {t("OTHER.close")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default MessageMobile;
